import { Box } from '@withjoy/joykit';
import React from 'react';
import { ReactComponent as CheckmarkIconOff } from './assets/todo-off.svg';
import { ReactComponent as CheckmarkIconOn } from './assets/todo-on.svg';
import { ReactComponent as CheckmarkIconOffHover } from './assets/todo-off-hover.svg';
import { ReactComponent as CheckmarkIconActive } from './assets/todo-active.svg';
import { animationTransition } from '@shared/utils/animationTransition';

interface ChecklistToDoMarkProps {
  completed: boolean;
  toggleCompleted: () => void;
}

export const ChecklistToDoMark: React.FC<ChecklistToDoMarkProps> = ({ completed, toggleCompleted }) => {
  return (
    <Box width={7} height={7} position={'relative'} role="group" onClick={toggleCompleted}>
      <Box
        position={'absolute'}
        opacity={0}
        transition={animationTransition('opacity')}
        _groupHover={{
          opacity: 1
        }}
      >
        <CheckmarkIconOffHover />
      </Box>
      <Box
        position={'absolute'}
        opacity={0}
        transition={animationTransition('opacity')}
        _groupActive={{
          opacity: 1
        }}
      >
        <CheckmarkIconActive />
      </Box>
      <Box>{completed ? <CheckmarkIconOn /> : <CheckmarkIconOff />}</Box>
    </Box>
  );
};
